import lf from 'lovefield'

export function simu_etudes (schemaBuilder) {
  schemaBuilder.createTable('simu_etudes')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('simu_eleves_id', lf.Type.INTEGER)
      .addColumn('exo_chantiers_id', lf.Type.INTEGER)
      .addColumn('debut', lf.Type.DATE_TIME)
      .addColumn('jour', lf.Type.INTEGER)
      .addColumn('jour_atteint', lf.Type.INTEGER)
      .addColumn('rendement', lf.Type.NUMBER)
      .addColumn('cout', lf.Type.NUMBER)
      .addColumn('qualite', lf.Type.INTEGER)
      .addColumn('securite', lf.Type.INTEGER)
      .addColumn('environnement', lf.Type.INTEGER)

      
      .addPrimaryKey(['id'], true)
      .addNullable(['debut', 'jour', 'rendement', 'cout', 'qualite', 'securite', 'environnement']);
}

/*
CREATE TABLE IF NOT EXISTS `simu-etudes` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `simu-eleves_id` int(11) NOT NULL,
  `exo-chantiers_id` int(11) NOT NULL,
  `debut` date NOT NULL,
  `jour` tinyint(4) NOT NULL,
  `rendement` float NOT NULL,
  `cout` float NOT NULL,
  `qualite` tinyint(4) NOT NULL,
  `securite` tinyint(4) NOT NULL,
  `environnement` tinyint(4) NOT NULL,
  PRIMARY KEY (`id`)
) ENGINE=InnoDB DEFAULT CHARSET=utf8 AUTO_INCREMENT=1 ;
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/simuEtudes.schema.js